export default "__VITE_ASSET__BJMlRdGG__"